export const currentNotificationNamespaceSelector = state =>
  state.currentNotification;

export const currentNotificationSelector = state =>
  currentNotificationNamespaceSelector(state).data;

export const currentNotificationRawDateSelector = state =>
  currentNotificationSelector(state).rawEventDate;

export const currentNotificationAppointmentStartSelector = state =>
  currentNotificationSelector(state).appointmentProposalStart;

export const currentNotificationStepSelector = state =>
  currentNotificationSelector(state).step;

export const currentNotificationTypeSelector = state =>
  currentNotificationSelector(state).type;
